import { Box, Card } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import Avatar from "react-avatar";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { startLoading, stopLoading } from "../../actions/loadingAction";
import { errorSnackbar } from "../../actions/snackbarActions";
import { Endpoint, Status } from "../../apis/apiConstants";
import AjaxHelper from "../../apis/apiRequest";
import "./singleHelpline.scss";

const SingleHelpline = (props) => {
  const { state } = useLocation();
  const [helpline, setHelpline] = useState({ fileUrls: [] });

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    getHelpline(state._id);
  }, []);

  const getHelpline = (id) => {
    dispatch(startLoading);
    AjaxHelper.getApi(navigate, `${Endpoint.GET_HELPLINE}/${id}`)
      .then((response) => {
        dispatch(stopLoading);
        if (response.data.status === Status.API_SUCCESS) {
          console.log(response.data.data);
          setHelpline(response.data.data);
        } else {
          dispatch(errorSnackbar("Error while fetching Help request."));
        }
      })
      .catch((err) => {
        dispatch(stopLoading);
        dispatch(errorSnackbar("Error while fetching Help request."));
      });
  };

  const handleOnFileClick = (fileUrl) => {
    window.open(fileUrl, "_blank", "noreferrer");
  };

  const getFileName = (fileName) => {
    const maxLength = 10;
    if (fileName) {
      const names = fileName.split(".");

      if (names[0].length > maxLength) {
        return (
          names[0].slice(0, maxLength) +
          "..." +
          names[0].slice(names.length - 5) +
          "." +
          names[1]
        );
      } else {
        return fileName;
      }
    }
  };

  return (
    <Box style={{ width: "100%", overflowX: "hidden" }}>
      <Card
        variant="outlined"
        style={{
          position: "relative",
          marginLeft: "10%",
          marginRight: "10%",
          marginTop: "3%",
          marginBottom: "5%",
          display: "flex",
          flexDirection: "column",
          overflowX: "hidden",
        }}
      >
        <div className={"helpline-component"}>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              gap: 8,
              padding: 8,
            }}
          >
            <Avatar
              name={`${helpline.postedBy?.firstName} ${helpline.postedBy?.lastName}`}
              round={true}
              size="80"
              textSizeRatio={3}
            />
            <div>
              <div
                className={"appFontMedium font-24"}
              >{`${helpline.postedBy?.firstName} ${helpline.postedBy?.lastName}`}</div>
              <div
                className={"appFontItalic font-22"}
              >{`${helpline.postedBy?.userCode}`}</div>
            </div>
          </div>
          <div>
            <div className={"components-align-left-row appFont p-3"}>
              <div>Mobile:</div>
              <div>{helpline.postedBy?.mobile}</div>
            </div>
            <div className={"components-align-left-row appFont p-3"}>
              <div>Email:</div>
              <div>{helpline.postedBy?.email}</div>
            </div>
          </div>
          <div
            style={{
              fontFamily: "MontserratBold",
              fontSize: 16,
              paddingRight: 16,
              paddingLeft: 16,
              marginTop: 16,
            }}
          >
            {helpline.subject}
          </div>
          <div
            style={{
              paddingRight: 16,
              paddingLeft: 16,
              display: "flex",
              flexDirection: "row",
              gap: 8,
              flexWrap: "wrap",
            }}
          >
            <div
              style={{ display: "flex", flexDirection: "column", gap: 8 }}
            ></div>
          </div>

          <ReactQuill
            value={helpline.blog}
            style={{
              wordWrap: "break-word",
              paddingLeft: 12,
              paddingRight: 12,
              marginBottom: 16,
            }}
            modules={{
              toolbar: false,
            }}
            formats={[
              "header",
              "bold",
              "italic",
              "underline",
              "strike",
              "blockquote",
              "code-block",
              "list",
              "bullet",
              "link",
              "image",
            ]}
            placeholder="Write something amazing..."
            readOnly
          />
        </div>
      </Card>
    </Box>
  );
};

export default SingleHelpline;
